import { Label } from "@/flokit/core/label/label";
import { Tooltip } from "@/flokit/core/tooltip/tooltip";
import { cx } from "class-variance-authority";
import { BsQuestionCircleFill } from "react-icons/bs";
import { Default, Hidden, LabelMethod } from "./label-prop";

type NonInteractiveInputLabelProps = {
  interactivity: "non-interactive";
  id: string;
};
type InteractiveInputLabelProps = {
  interactivity: "interactive";
  idOfElementToBeLabeled: string;
};
type InputLabelProps = (
  | NonInteractiveInputLabelProps
  | InteractiveInputLabelProps
) & {
  // For other label methods, the caller is providing the element that serves as the label.
  labelMethod: Extract<LabelMethod, Default | Hidden>;
  isRequired?: boolean;
  isDisabled?: boolean;
  tooltip?: string;
};

export const InputLabel = (props: InputLabelProps) => {
  switch (props.labelMethod.type) {
    case "default":
      if (props.interactivity === "interactive")
        return (
          <div className={cx("flex items-center gap-x-1")}>
            <Label
              interactivity="interactive"
              htmlFor={props.idOfElementToBeLabeled}
              text={props.labelMethod.label}
              isRequired={props.isRequired}
              isDisabled={props.isDisabled}
            />
            {props.tooltip ? (
              <Tooltip content={props.tooltip} align="center" side="top">
                <BsQuestionCircleFill size={12} />
              </Tooltip>
            ) : null}
          </div>
        );
      else
        return (
          <div className={cx("flex items-center gap-x-1")}>
            <Label
              interactivity="non-interactive"
              id={props.id}
              text={props.labelMethod.label}
              isRequired={props.isRequired}
              isDisabled={props.isDisabled}
            />
            {props.tooltip ? (
              <Tooltip content={props.tooltip} align="center" side="top">
                <BsQuestionCircleFill size={12} />
              </Tooltip>
            ) : null}
          </div>
        );
    case "hidden":
      if (props.interactivity === "interactive")
        return (
          <label className="sr-only" htmlFor={props.idOfElementToBeLabeled}>
            {props.labelMethod.label}
          </label>
        );
      else
        return (
          <p className="sr-only" id={props.id}>
            {props.labelMethod.label}
          </p>
        );
    default:
      return null;
  }
};
